import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEchartsCore } from 'ngx-echarts';

export function provideLogiviceECharts(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideEchartsCore({ echarts: (): Promise<unknown> => import('./echarts.setup').then(m => m.echarts) })
    ]);
}

export { BKLIT_THEME_NAME } from './echarts-bklit.theme';
